export { default } from "./imageCard";
